import API_BASE_URL from '../config/api';

/**
 * Scope of work, written once per equipment category.
 *
 * The office writes these; techs read them while filling out a checklist. The
 * text is free-form and is stored and returned byte for byte, so whatever
 * indentation and line breaks the office uses survive to the tech's screen —
 * render it with `white-space: pre-wrap`.
 */
export async function fetchEquipmentScopes({ withCategories = false } = {}) {
  const query = withCategories ? '?withCategories=1' : '';
  const response = await fetch(`${API_BASE_URL}/api/mechanical/equipment-scopes${query}`);
  if (!response.ok) throw new Error(`Failed to load equipment scopes: ${response.status}`);
  return response.json();
}

/**
 * Save scopes. Only the categories passed in are written, so saving one card
 * can't flatten the rest.
 */
export async function saveEquipmentScopes(scopes) {
  const token = localStorage.getItem('managerToken');
  const response = await fetch(`${API_BASE_URL}/api/mechanical/equipment-scopes`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ scopes }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Failed to save equipment scopes: ${response.status}`);
  }
  return response.json();
}
